// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ehVBw","checkboxCol":"Table_checkboxCol__NrCmc","emailCol":"Table_emailCol__SF0Ea","actionCol":"Table_actionCol__27AEU"};